export * from './communication.module';
export * from './communication.routes';